export default String.raw`
{% if include contains '|' -%}
    {% assign includeArr = include | Split:'|' -%}
    {% assign countryISOCode = includeArr[0] -%}
    {% assign include = includeArr[1] -%}
{% else -%}
    {% assign countryISOCode = config.Countries[0].ISOCode -%}
{% endif -%}

{% assign cityRequired = config.Countries[countryISOCode].RequiredFields.City -%}
{% assign streetRequired = config.Countries[countryISOCode].RequiredFields.Street -%}
{% assign streetNoRequired = config.Countries[countryISOCode].RequiredFields.StreetNo -%}
{% assign TINRequired = config.Countries[countryISOCode].RequiredFields.TIN -%}
{% assign zipCodeRequired = config.Countries[countryISOCode].RequiredFields.ZipCode -%}

<input type="hidden" name="__action" value="Customer/Register">
<input type="hidden" name="company" value="{% if include == 'company' -%} true {% endif -%}">
<div class="register-step-js">
{% if include == 'company' -%}
    <div class="reg-container__data">
        {{ translations.AccountDetails }}
    </div>
{% endif -%}
    <div class="form__input-wrapper email">
        <label for="customerEmail" data-type="email" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.Email }}</label>
        <input class="form__input-value input-value-js onlyInputEventValidation" id="customerEmail" type="email" name="email" value="{{ customer.Email }}" autocomplete="email" maxlength="192" required >
        <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
        <div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
    </div>
    <div class="form__input-wrapper password">
        <label for="customerPassword" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.Password }}</label> 
        <input id="customerPassword" type="password" class="form__input-value input-value-js onlyInputEventValidation" name="password" value="" title="{{translations.ShowPassword}}" maxlength="50" required autocomplete="new-password" >
        <div tabindex="0" role="button" aria-label="{{ translations.HideShowPassword }}" class="form__icons form__preview form__preview-js">
                <svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#eye-{{settings.iconStyle}}"></use></svg>
        </div>
        <div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
        <div class="validation-info__container validation-info-js password-valid-js hidden-js">
            {{ translations.PasswordMustHave }}
            <div class="validation-info__element min-8-char-js">
                <svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
                <span class="validation-info">{{ translations.Min8Char }}</span>
            </div>
            <div class="validation-info__element big-letter-js">
                <svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
                <span class="validation-info">{{ translations.BigLetter }}</span>
            </div>
            <div class="validation-info__element small-letter-js">
                <svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
                <span class="validation-info">{{ translations.SmallLetter }}</span>
            </div>
            <div class="validation-info__element digit-js">
                <svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
                <span class="validation-info">{{ translations.Digit }}</span>
            </div>
            <div class="validation-info__element special-char-js">
                <svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
                <span class="validation-info">{{ translations.SpecialChar }}</span>
            </div>
        </div>
    </div>
{% if include == 'company' -%}
    <div class="form__input-wrapper form__input-wrapper__country">
        <label for="countryCode-2" class="form__input-info input-info-js on-label">{{ translations.Country }}</label>
        <select id="countryCode-2" name="countryCode" class="form__input-value input-value-js reg-container__select register-country-js register-country">
            {% for country in config.Countries -%}
            <option {% if country.ISOCode == countryISOCode -%} selected {% endif -%} value="{{ country.ISOCode }}" data-tin-regex="{{ country.TINRegex }}" data-zip-regex="{{ country.ZipCodeRegex }}" data-zip-format="{{ country.ZipCodeFormat }}">
                {{ config.Countries[country.ISOCode].Name }}
            </option>
            {% endfor -%}
        </select>
    </div>
    <div class="register-js" data-template="partials/common/address-form-register.html"> 
        {% include 'partials/common/address-form-register.html' with 'company' -%}
    </div>
{% else -%}
    {% include 'partials/common/address-form.html' with 'retail' -%}
{% endif -%}
{% if include == 'retail' -%}
    {% include 'partials/common/consents.html', consentsArea: 'registration', index: '1' -%}
    <div class='reg-container__required-fields'><span class='required'>*</span> {{ translations.RequiredFields }}</div>
    <button class="primary-action-button reg-container__submit register-submit-js">
        <span>{{ translations.MakeAccount }}</span>
    </button>
    <span class="reg-container__LogIn">
        {{ translations.HaveAccount }}
        <a href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}" title="{{ translations.LogIn }}">
            {{ translations.LogIn}}
        </a>
    </span>
{% endif -%}
</div>
{% if include == 'company' -%}
    <div class="second-step-js">
        <div class="reg-container__data">{{ translations.AddressDetails }}</div>
        <div class="form__input-wrapper">
            <label for="name" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.CompanyName }}</label>
            <input class="form__input-value input-value-js" id="name" type="text" name="name" value="{{ customer.Address.Name | H }}" maxlength="50" required>
            <div class="form__invalid-input validation-required-js hidden-js">
                {{ translations.FillCompanyName }}
            </div>
        </div>
        <div class="form__input-wrapper" name="name2">
            <label for="name2" class="form__input-info input-info-js">{{ translations.CompanyName }}</label>
            <input class="form__input-value input-value-js" id="name2" type="text" name="name2" autocomplete="organization" value="{{ customer.Address.Name2 | H }}" maxlength="50">
        </div>
        <div class="form__input-wrapper">
            <label for="street" class="form__input-info input-info-js">{% if addressRequired and streetRequired -%}<span class='required'>* </span>{% endif -%}{{ translations.Street }}</label>
            <input class="form__input-value input-value-js" id="street" type="text" name="street" value="{{ customer.Address.Street | H }}" maxlength="50" {% if addressRequired and streetRequired -%} required {% endif -%}>
            {% if addressRequired and streetRequired -%}
            <div class="form__invalid-input validation-required-js hidden-js">
                {{ translations.FillStreet }}
            </div>
            {% endif -%}
        </div>
        <div class="reg-container__input-wrappers-home">
            <div class="form__input-wrapper">
                <label for="streetNo" class="form__input-info input-info-js">{% if addressRequired and streetNoRequired -%}<span class='required'>* </span>{% endif -%}{{ translations.HouseNumber }}</label>
                <input class="form__input-value input-value-js" id="streetNo" type="text" name="streetNo" value="{{ customer.Address.StreetNo }}" maxlength="20" {% if addressRequired and streetNoRequired -%} required {% endif -%}>
                {% if addressRequired and streetNoRequired -%}
                <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillHouseNumber }}</div>
                {% endif -%}
            </div>
            <div class="form__input-wrapper">
                <label for="unitNo" class="form__input-info input-info-js">{{ translations.FlatNumber }}</label>
                <input class="form__input-value input-value-js" id="unitNo" type="text" name="unitNo" value="{{ customer.Address.UnitNo }}" maxlength="20">
            </div>
        </div>
        <div class="reg-container__input-wrappers-city">
            <div class="form__input-wrapper">
                <label for="zipCode" class="form__input-info input-info-js">{% if addressRequired and zipCodeRequired -%}<span class='required'>* </span>{% endif -%}{{ translations.ZipCode }}</label>
                <input class="form__input-value input-value-js" id="zipCode" type="text" name="zipCode" value="{{ customer.Address.ZipCode }}" {% if addressRequired and zipCodeRequired -%} required {% endif -%} maxlength="20">
                {% if addressRequired and zipCodeRequired -%}
                    <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillZipCode }}</div>
                {% endif -%}
                <div class="form__invalid-input validation-zip-code-js hidden-js">{{ translations.FillProperZipCode }} <span class="zip-format-js"></span></div>
            </div>
            <div class="form__input-wrapper">
                <label for="city" class="form__input-info input-info-js">{% if addressRequired and cityRequired -%}<span class="required">* </span>{% endif -%}{{ translations.City }} </label>
                <input class="form__input-value input-value-js" id="city" type="text" name="city" value="{{ address.City | H }}" maxlength="50" {% if addressRequired and cityRequired -%} required {% endif -%} {% if readonly -%} readonly {% endif -%} >
                {% if addressRequired and cityRequired -%}
                    <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillCity }}</div>
                {% endif -%}
            </div>
        </div>
        {% if config.Registration.Company.PhoneVisible -%}
        <div class="form__input-wrapper">
            <label for="phoneNo" class="form__input-info input-info-js">
                {% if config.Registration.Company.PhoneRequired -%}<span class='required'>* </span>{% endif -%}
                {{ translations.PhoneNumber }}
            </label>
            <input class="form__input-value input-value-js" id="phoneNo" type="tel" inputmode="numeric" pattern="\d*" name="phoneNo" value="{{ address.PhoneNo }}" maxlength="22" {% if config.Registration.Company.PhoneRequired -%} required {% endif -%}>
            {% if config.Registration.Company.PhoneRequired -%}
            <div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillPhoneNumber }}</div>
            {% endif -%}
        </div>
        {% endif -%}
        {% include 'partials/common/consents.html', consentsArea: 'registration', index: '2' -%}
        <div class='reg-container__required-fields'><span class='required'>*</span> {{ translations.RequiredFields }}</div>
        <button class="primary-action-button reg-container__submit register-submit-js">
            <span>{{ translations.MakeAccount }}</span>
        </button>
        <span class="reg-container__LogIn">
            {{ translations.HaveAccount }}
            <a href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}" title="{{ translations.LogIn }}">
                {{ translations.LogIn}}
            </a>
        </span>
    </div>
{% endif -%}
`